import {gql} from 'apollo-angular';

export const GET_GAME_CATEGORIES_PER_GAME = gql`
  query GetGameCategoriesPerGame($clientId: String!) {
    getGameCategoriesPerGame(clientID: $clientId) {
      status {
        type
        message
      }
      guessTheJob
      quiz
    }
  }
`;
